import { combineReducers } from '@reduxjs/toolkit'
import project from './projectSlice'

const reducer = combineReducers({
    project,
    
})

export default reducer